import { createSelector } from 'reselect';
import { MESSAGE_MEDIUM_NODE_TYPE_MAP, NODE_TYPES } from 'modules/workflows/constants';
import { ChannelOptNodeData } from 'modules/workflows/types';
import { MessageMedium } from 'constants/messageMediums';
import { getNodes } from './nodes';
import { WorkflowsRootState } from '../ducks.types';

export const getInProgressVisitorCount = (state: WorkflowsRootState) =>
  state.workflow?.workflow?.inProgressCount;

export const getInProgressCountRetrievedTimestamp = (state: WorkflowsRootState) =>
  state.workflow?.workflow?.InProgressCountRetrievedTimestamp;

export const getIsAsyncLoading = (state: WorkflowsRootState) => state.workflow?.isAsyncLoading;

/**
 * Returns a list of all medium types used in the workflow
 */
export const selectCampaignMediumsInWorkflow = createSelector([getNodes], (nodes) => {
  const updateAcc = (acc: MessageMedium[], c: string) => {
    const medium = MESSAGE_MEDIUM_NODE_TYPE_MAP[c] as MessageMedium | undefined;
    if (medium && !acc.includes(medium)) {
      acc.push(medium);
    }
  };

  return nodes
    .filter((node) => Number(node.id) > 0)
    .reduce((acc, n) => {
      const nodeType = n?.type;

      if (nodeType === NODE_TYPES.CHANNEL_OPT) {
        ((n?.nodeData as ChannelOptNodeData)?.childNodes || []).forEach((childNode) => {
          updateAcc(acc, childNode.type);
        });
      } else {
        updateAcc(acc, nodeType);
      }

      return acc;
    }, []);
});
